define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Container"
], function(declare,_,Container) {

	return declare(Container, {
		_getTextValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return array of formatted key/value pairs
			return _.map(value, function(v, k) {
				return k + "=" + this.formatValue(v);
			}, this.renBase);
		}
	});
});